(() => {
  function init(root = document) {
    root.querySelectorAll('[data-mp-gallery]').forEach(gallery => {
      if (gallery.dataset.ready) return;
      gallery.dataset.ready = 'true';
      gallery.addEventListener('click', event => {
        const button = event.target.closest('[data-mp-thumb]');
        if (!button) return;
        const source = button.querySelector('img');
        const target = gallery.querySelector('.mp-gallery-main');
        if (button.dataset.mpSrcset) target.srcset = button.dataset.mpSrcset;
        else target.removeAttribute('srcset');
        target.src = button.dataset.mpFull || source.dataset.mpOriginal || source.src;
        target.alt = source.alt;
        gallery.querySelectorAll('[data-mp-thumb]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
      });
    });
  }
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') {
      document.querySelectorAll('.mp-mobile-menu[open]').forEach(menu => { menu.open = false; menu.querySelector('summary').focus(); });
    }
  });
  let dimensions = null;
  let fileUnreadable = false;
  let requestId = 0;
  const quality = document.querySelector('[data-mp-quality]');
  if (!quality) return;
  const output = quality.querySelector('output');
  const initialMessage = output.textContent;
  document.addEventListener('click', event => {
    if (event.target.closest('.tpo-delete__file')) {
      dimensions = null; fileUnreadable = false; ++requestId;
      output.textContent = initialMessage;
    }
    if (fileUnreadable && event.target.closest('button[name="add"]')) {
      event.preventDefault(); event.stopImmediatePropagation();
      output.textContent = quality.dataset.error;
      quality.open = true; output.scrollIntoView({ block: 'center' });
    }
  }, true);
  const formSection = quality.closest('[data-product-mode]');
  function report() {
    if (!dimensions) return;
    const selected = [...formSection.querySelectorAll('.mp-variants input:checked')].map(input => input.value).join(' ');
    let format = selected.match(/(\d+(?:[.,]\d+)?)\s*[x×]\s*(\d+(?:[.,]\d+)?)/i);
    let cm = format ? [Number(format[1].replace(',','.')),Number(format[2].replace(',','.'))] : /\bA4\b/i.test(selected) ? [21,29.7] : null;
    const [w,h] = dimensions;
    let message = `${w} × ${h} px · ${(w*h/1e6).toFixed(1)} MP`;
    if (cm && cm.every(n => n > 0)) {
      // Either orientation is allowed; both dimensions constrain the fit-to-fill calculation.
      const pixels = [w,h].sort((a,b)=>a-b); cm.sort((a,b)=>a-b);
      const ppi = Math.min(pixels[0]/(cm[0]/2.54),pixels[1]/(cm[1]/2.54));
      message += `\n${cm.join(' × ')} cm · ≈ ${Math.round(ppi)} ppi`;
      if (ppi < 150) message += '\n' + quality.dataset.low;
    } else message += '\n' + quality.dataset.format;
    output.textContent = message;
  }
  document.addEventListener('change', event => {
    if (event.target.matches('.mp-variants input')) { report(); return; }
    if (!event.target.matches('input[type=file]')) return;
    const file = event.target.files?.[0];
    if (!file) return;
    const id = ++requestId;
    dimensions = null; fileUnreadable = false;
    if (!file.type.startsWith('image/')) { output.textContent = quality.dataset.invalid; return; }
    const objectURL = URL.createObjectURL(file);
    const image = new Image();
    image.onload = () => { URL.revokeObjectURL(objectURL); if (id !== requestId) return; dimensions=[image.naturalWidth,image.naturalHeight]; report(); };
    image.onerror = () => { URL.revokeObjectURL(objectURL); if (id === requestId) { output.textContent=quality.dataset.error; fileUnreadable = ['image/png', 'image/jpeg'].includes(file.type); } };
    image.src = objectURL;
  }, true);
})();
